
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        calculationType: {
            type: String,
            default: null
        },
    }
})
